import { render, staticRenderFns } from "./GridRowLabel.vue?vue&type=template&id=13adecbe&scoped=true"
import script from "./GridRowLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridRowLabel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GridRowLabel.vue?vue&type=style&index=0&id=13adecbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13adecbe",
  null
  
)

export default component.exports